import CartSidebar from '~domain/entities/CartSidebar/CartSidebar';
import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/CartService';

export default class SetItemAddedUseCase {
    private readonly displayItemAddedText: boolean = false;
    private cartSidebar: CartSidebar;

    constructor(displayItemAddedText: boolean) {
        this.displayItemAddedText = displayItemAddedText;
        this.cartSidebar = diContainer.get(serviceNames.cartSidebar);
    }

    public execute = () => {
        this.cartSidebar.setDisplayItemAddedText(this.displayItemAddedText);
    };
}
